import React, { useMemo } from 'react';
import { View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import { API_PATH } from 'config';
import { useTemplateColors } from 'PDF/TemplateEngine/TemplateColorsContext';

// Header hardcoded legacy. Se monta desde TemplateRenderer cuando el template
// NO tiene una section con type='header' en sections[]. Preserva el look
// original (logo + empresa + nombre del documento en primary color).
// Templates que quieren customización completa deben agregar una section
// type='header' con config — ver HeaderSection.jsx.
function LegacyHeaderSection({ template, config }) {
  const { colors, FONT } = useTemplateColors();
  const styles = useMemo(
    () =>
      StyleSheet.create({
        header: {
          position: 'absolute',
          top: '0.8cm',
          left: '1.5cm',
          right: '1.5cm',
          height: '2cm',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderBottom: `1.5px solid ${colors.primary}`,
          paddingBottom: '0.25cm',
        },
        left: {
          flexDirection: 'row',
          alignItems: 'center',
          gap: '0.3cm',
        },
        logo: {
          width: '2.8cm',
          height: '1.4cm',
          objectFit: 'contain',
        },
        company: {
          fontSize: 11,
          fontFamily: FONT.bold,
          color: colors.darkText,
        },
        title: {
          fontSize: 12,
          fontFamily: FONT.bold,
          color: colors.primary,
          textTransform: 'uppercase',
        },
      }),
    [colors, FONT]
  );

  const logoPath = template?.logo || config?.portraitLogo;
  const logoSrc = logoPath ? `${API_PATH}${logoPath}` : null;

  return (
    <View style={styles.header} fixed>
      <View style={styles.left}>
        {logoSrc ? <Image src={logoSrc} style={styles.logo} /> : null}
        <Text style={styles.company}>{config?.company || ''}</Text>
      </View>
      <Text style={styles.title}>{template?.name || ''}</Text>
    </View>
  );
}

export default LegacyHeaderSection;
